$(document).ready(function () {
    let ajaxLockActive = false;

    const ajaxPath = '/action/voucher';
    const ajaxPathExpiresDate = 'expires-date';
    const ajaxPathBulkDeactivation = 'bulk-deactivation';
    const ajaxPathExportExcel = 'excel';
    const ajaxPathExportPdf = 'pdf';

    $(document).on('click', '#active_vouchers_table .voucher_edit_expires_date_btn', function(e) {
        e.preventDefault();
        e.stopPropagation();

        if (ajaxLockActive) {
            return false;
        }

        showPreloader();
        ajaxLockActive = true;

        const btn = $(this);
        const voucherNumber = btn.attr("data-voucher-number");
        const tr = btn.parents('tr').first();
        const input = btn.parents('.voucher_expires_date').first().find('.voucher_edit_expires_date_input');
        const expiresDate = input.val();

        $.ajax({
            type: 'POST',
            url: `${ajaxPath}/${voucherNumber}/${ajaxPathExpiresDate}`,
            data: {
                expires_date: expiresDate
            },
            dataType: 'json',
        }).success(function (data) {
            input.attr('data-old-value', input.val());
            if (data.is_expired === true) {
                tr.addClass('danger');
            } else {
                tr.removeClass('danger');
            }
            btn.hide();
        }).error(function (data) {
            const message = extractErrorMessage(data, 'Feil ved oppdatering av utløpsdato');
            displayInfoMessageModal($('#chart_content', document), 'Det oppstod en feil!', message, 'Lukk', 'error');
        }).always(function () {
            ajaxLockActive = false;
            hidePreloader();
        });
        return false;
    });

    $("#active_vouchers_table .voucher_edit_expires_date_input", document).datepicker({
        dateFormat: "dd/mm/yy",
        changeMonth: true,
        changeYear: true,
        showButtonPanel: true,
        onSelect: function(dateText, inst) {
            const input = $(inst.input);
            const btn = input.parents('.voucher_expires_date').first().find('.voucher_edit_expires_date_btn');
            const oldDate = input.attr('data-old-value').trim();
            if (oldDate == dateText) {
                btn.hide();
            } else {
                btn.show();
            }
        }
    });

    $('#datepicker_date_from_vouchers, #datepicker_date_to_vouchers', document).datepicker({
        dateFormat: "dd/mm/yy",
        changeMonth: true,
        changeYear: true,
        showButtonPanel: true
    });

    $('#show_deactivated_vouchers', document).on('click', function(e) {
        const btn = $(this);
        const table = $('#deactivated_vouchers', document);
        if (table.is(':visible')) {
            table.hide();
            btn.html('Vis deaktiverte tilgodelapper');
        } else {
            table.show();
            btn.html('Skjul deaktiverte tilgodelapper');
        }

        return false;
    });

    $('#deactivate_vouchers', document).on('click', function(e) {
        e.preventDefault();

        const inputs = $(`#active_vouchers_table input[name="vouchers_deactivate[]"]:checked`, document);
        if (!inputs.length) {
            return false;
        }

        const voucherNumbers = [];
        inputs.each(function() {
            const input = $(this);
            const voucherNumber = input.attr('data-voucher-number');
            if (voucherNumber) {
                voucherNumbers.push(voucherNumber);
            }
        });

        if (ajaxLockActive) {
            return false;
        }

        showPreloader();
        ajaxLockActive = true;

        $.ajax({
            type: 'POST',
            url: `${ajaxPath}/${ajaxPathBulkDeactivation}`,
            data: {
                voucher_numbers: voucherNumbers
            },
            dataType: 'json',
        }).success(function (data) {
            window.location.reload();
        }).error(function (data) {
            const message = extractErrorMessage(data, 'Feil ved massedeaktivering');
            displayInfoMessageModal($('#chart_content', document), 'Det oppstod en feil!', message, 'Lukk', 'error');
        }).always(function () {
            ajaxLockActive = false;
            hidePreloader();
        });

        return false;
    });


    $('#export_deactivated_vouchers_excel', document).click(function () {
        if (ajaxLockActive) {
            return false;
        }

        showPreloader();
        ajaxLockActive = true;

        const dateFrom = $('#datepicker_date_from_vouchers', document).val();
        const dateTo = $('#datepicker_date_to_vouchers', document).val();

        $.ajax({
            type: 'GET',
            url: `${ajaxPath}/${ajaxPathExportExcel}`,
            data: {
                date_from: dateFrom,
                date_to: dateTo,
            },
            dataType: 'json',
        }).success(function (data) {
            window.location = '/includes/report/excels/' + data.excel_file_name;
        }).error(function (data) {
            const message = extractErrorMessage(data, 'Feil ved eksport av Excel fil');
            displayInfoMessageModal($('#chart_content', document), 'Det oppstod en feil!', message, 'Lukk', 'error');
        }).always(function () {
            ajaxLockActive = false;
            hidePreloader();
        });

        return false;
    });


    $('#export_deactivated_vouchers_pdf', document).click(function () {
        if (ajaxLockActive) {
            return false;
        }

        showPreloader();
        ajaxLockActive = true;

        const dateFrom = $('#datepicker_date_from_vouchers', document).val();
        const dateTo = $('#datepicker_date_to_vouchers', document).val();

        const params = new URLSearchParams({
            date_from: dateFrom,
            date_to: dateTo,
        });

        fetch(`${ajaxPath}/${ajaxPathExportPdf}?${params.toString()}`, {
            method: 'GET'
        }).then(response => {
                if (!response.ok) {
                    throw new Error();
                }
                return response.blob();
            }).then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'deaktiverte_tilgodelapper_rapport.pdf';
                document.body.appendChild(a);
                a.click();
                a.remove();

                ajaxLockActive = false;
                hidePreloader();
            }).catch(data => {
                const message = extractErrorMessage(data, 'Feil ved eksport av PDF fil');
                displayInfoMessageModal($('#chart_content', document), 'Det oppstod en feil!', message, 'Lukk', 'error');

                ajaxLockActive = false;
                hidePreloader();
            });

        return false;
    });

    function extractErrorMessage(data, defaultMessage) {
        if (!data || !data.responseText) {
            return defaultMessage;
        }

        try {
            const parsed = JSON.parse(data.responseText);
            if (parsed && typeof parsed === 'object' && parsed.error_message) {
                return parsed.error_message;
            }
            return defaultMessage;
        } catch (e) {
            return defaultMessage;
        }
    }
});